import { computed, ref } from 'vue';
import AgentConsentsAPI from 'dashboard/api/agentConsents';
import { useAlert } from 'dashboard/composables';
import {
  AMBASSADOR_CONSENT_PURPOSE,
  LEGACY_AMBASSADOR_CONSENT_PURPOSE,
} from '../utils/reportConstants';

// SPEC 29 / P37-4 — consentimento do programa Embaixador (LGPD): listagem,
// aceite e revogação por propósito registrado.
export function useAgentConsents() {
  const agentConsents = ref([]);
  const agentConsentsLoading = ref(false);
  const agentConsentSaving = ref('');

  // SPEC 29 / P37-4 — o termo completo (ConsentTerm) substitui o toggle binário.
  const ambassadorConsent = computed(() =>
    agentConsents.value.find(
      item =>
        item.purpose === AMBASSADOR_CONSENT_PURPOSE ||
        item.purpose === LEGACY_AMBASSADOR_CONSENT_PURPOSE
    )
  );

  const loadAgentConsents = async () => {
    agentConsentsLoading.value = true;
    try {
      const { data } = await AgentConsentsAPI.list();
      agentConsents.value = data.data || [];
    } catch {
      useAlert('Não foi possível carregar consentimentos.');
    } finally {
      agentConsentsLoading.value = false;
    }
  };

  const acceptAmbassadorConsent = async (metadata = {}) => {
    agentConsentSaving.value = 'accept';
    try {
      await AgentConsentsAPI.accept(AMBASSADOR_CONSENT_PURPOSE, {
        surface: 'relatorio',
        accepted_text: 'Programa Embaixador Imudei',
        ...metadata,
      });
      useAlert('Consentimento registrado.');
      await loadAgentConsents();
    } catch (error) {
      useAlert('Não foi possível registrar o consentimento.');
      throw error;
    } finally {
      agentConsentSaving.value = '';
    }
  };

  const revokeAmbassadorConsent = async (metadata = {}) => {
    agentConsentSaving.value = 'revoke';
    try {
      await AgentConsentsAPI.revoke(AMBASSADOR_CONSENT_PURPOSE, {
        surface: 'relatorio',
        reason: 'revoked_by_agent',
        ...metadata,
      });
      useAlert('Consentimento revogado.');
      await loadAgentConsents();
    } catch (error) {
      useAlert('Não foi possível revogar o consentimento.');
      throw error;
    } finally {
      agentConsentSaving.value = '';
    }
  };

  return {
    agentConsents,
    agentConsentsLoading,
    agentConsentSaving,
    ambassadorConsent,
    loadAgentConsents,
    acceptAmbassadorConsent,
    revokeAmbassadorConsent,
  };
}
